import { getUserTransactions } from '@/services/transactionService';
import { TGetTransactionsParams } from '@/types/transactions/transaction-types';
import { useInfiniteQuery } from '@tanstack/react-query';

const useGetTransactions = (filter?: TGetTransactionsParams) => {
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    isLoading,
    status,
    isError,
    refetch,
    isPending,
  } = useInfiniteQuery({
    queryKey: ['transactions', filter],
    queryFn: async (args) => {
      const { pageParam } = args;
      return getUserTransactions({
        next_cursor: pageParam,
        ...filter,
      });
    },
    initialPageParam: '',
    getNextPageParam: (lastPage) => lastPage?.next_cursor,
    select: (data) => data?.pages.flatMap((page) => page.transactions),
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
  return {
    data: Array.isArray(data) ? data.filter((item) => !!item) : data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isLoading,
    isFetchingNextPage,
    isError,
    status,
    refetch,
    isPending,
  };
};

export default useGetTransactions;
